module.exports = __webpack_public_path__ + "static/media/mycard.c43bea3f.png";